/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DataTable from "examples/Tables/DataTable";
import { CircularProgress, Icon, Tooltip } from "@mui/material";

//React Hooks and Others
import { useEffect } from "react";
import PropTypes from "prop-types";
import { useLazyGetLoteByIdQuery, useGetLotesQuery } from "services";
import { admin_state, setEditAdmin } from "slices";
import { useSelector } from "react-redux";
import ModalLoteShow from "components/PDF/modal_pdf";
import { style_icon } from "helpers/global_vars";
import { useRedirectForm } from "hooks/useRedirectForm";
import useModalHandler from "../../../../hooks/useModalHandler";
import usePagination from "hooks/usePagination";

function DataTableMovimientosAsignacion({ tableHeader }) {
  const { edit } = useSelector(admin_state);

  const {
    offset,
    setOffset,
    limit,
    busqueda,
    setBusqueda,
    handleNext,
    handlePrevious,
  } = usePagination();

  const {
    open: openShow,
    handleOpen: handleOpenShow,
    handleClose: handleCloseShow,
  } = useModalHandler();

  const {
    data: activos_asig,
    isError: isErrorG,
    isLoading: isLoadingG,
    error: errorG,
  } = useGetLotesQuery(
    {
      filter_params: {
        buscar: busqueda,
        offset: offset,
        limit: limit,
        type: "Asignación",
        query:
          "{id,creacion,,operaciones{activo{id,llave,numero_de_inventario,descripcion,borrable,numero_de_serie,estado{nombre}}}}",
      },
      shape: {
        idLote: "id",
        id: "operaciones[].activo.id",
        llave: "operaciones[].activo.llave",
        numero_de_inventario: "operaciones[].activo.numero_de_inventario",
        descripcion: "operaciones[].activo.descripcion",
        borrable: "operaciones[].activo.borrable",
        numero_de_serie: "operaciones[].activo.numero_de_serie",
        estado: "operaciones[].activo.estado.nombre",
        creacion: "creacion",
      },
    },
    {
      refetchOnReconnect: true,
    }
  );

  //constantes para manejar la paginacion
  const dataLotes = activos_asig?.results ? activos_asig.results : activos_asig;
  const countTotal = activos_asig?.count;
  const previous = activos_asig?.previous;
  const next = activos_asig?.next;

  const [getLoteById, { data: lote }] = useLazyGetLoteByIdQuery();

  const dataTable = {
    columns: [
      {
        Header: "No. inventario",
        accessor: "numero_de_inventario",
        Cell: ({ value }) => {
          return value ? value : "-------------";
        },
      },
      {
        Header: "Descripcion",
        accessor: "descripcion",
      },
      {
        Header: "Estado",
        accessor: "estado",
      },
      {
        Header: "Fecha",
        accessor: "creacion",
      },
      {
        Header: "Nombre y Apellidos",
        accessor: "personal",
        width: "20%",
        Cell: ({ value }) => {
          return value ? value : "-------------";
        },
      },
      {
        Header: "Acciones",
        accessor: "acciones",
        Cell: ({ row }) => {
          const { original } = row;

          return (
            <MDBox>
              {original.resourcetype === "Tangible" && (
                <MDBox px={0.3}>
                  <Tooltip placement="top" title="Mostrar PDF">
                    <Icon
                      style={style_icon}
                      onClick={() => handleClickShowPdf(original.id)}
                      fontSize="small"
                    >
                      picture_as_pdf
                    </Icon>
                  </Tooltip>
                </MDBox>
              )}
            </MDBox>
          );
        },
      },
    ],
    rows: dataLotes ?? [],
  };

  useRedirectForm(
    isLoadingG,
    null,
    isErrorG,
    errorG,
    "Hubo problemas para cargar la información",
    null
  );

  useEffect(() => {
    if (edit !== null) {
      setEditAdmin(null);
    }
  }, [edit]);

  const handleClickShowPdf = (id) => {
    getLoteById(id);
    handleOpenShow();
  };

  return (
    <MDBox pt={6} pb={3}>
      {lote && (
        <ModalLoteShow
          open={openShow}
          handleClose={handleCloseShow}
          lote={lote}
        />
      )}
      <Card>
        <MDBox
          display="flex"
          justifyContent={"space-between"}
          alignItems={"center"}
          m={2}
          p={3}
        >
          <MDTypography variant="h5" fontWeight="medium">
            {tableHeader}
          </MDTypography>
        </MDBox>

        <MDBox display="flex" justifyContent={"center"} alignItems={"center"}>
          {isLoadingG ? (
            <CircularProgress sx={{ marginBottom: "3rem" }} color="inherit" />
          ) : (
            <DataTable
              table={dataTable}
              canSearch
              paginationApi
              countTotal={countTotal}
              next={next}
              previous={previous}
              handleNext={handleNext}
              handlePrevious={handlePrevious}
              offset={offset}
              setOffset={setOffset}
              setBusqueda={setBusqueda}
            />
          )}
        </MDBox>
      </Card>
    </MDBox>
  );
}

DataTableMovimientosAsignacion.propTypes = {
  tableHeader: PropTypes.string.isRequired,
};

export default DataTableMovimientosAsignacion;
